// Short questions and answers under the board on the start page. The same
// list feeds the FAQ structured data (Layout/Canonical.jsx), so what search
// engines read is exactly what visitors see. Keep answers short and plain:
// they're what AI summaries quote.
const HOME_FAQ = [
    {
        q: 'Can I play Sequence online for free?',
        a: 'Yes. Every game is free, with no account, no download and no limit on how many you play. It runs in the browser on a phone, tablet or computer.',
    },
    {
        q: 'Can I play Sequence against the computer?',
        a: 'Yes. Choose Play the computer and pick Easy, Medium or Hard. Wins against the computer count on the leaderboard.',
        path: '/play-against-computer',
    },
    {
        q: 'How do I play Sequence online with friends?',
        a: 'Start a game, copy the link and send it to your friends. They join from their own phone or computer, no sign-up needed. You can video call and chat while you play.',
        path: '/play-with-friends',
    },
    {
        q: 'How many people can play?',
        a: 'From 2 to 12 players, in 2 or 3 teams of the same size. With 2 teams you need two sequences to win; with 3 teams, one.',
        path: '/how-many-players',
    },
    {
        q: 'Can 3 people play Sequence?',
        a: 'Yes. Each player has their own colour, and the first to make one sequence of five chips wins.',
        path: '/how-many-players',
    },
    {
        q: 'What are the rules of Sequence?',
        a: 'Play a card, put a chip on a matching space on the 10 by 10 board, and make rows of five. Two-eyed Jacks are wild, one-eyed Jacks remove a chip, and the four corners count for everyone.',
        path: '/how-to-play',
    },
];

export default HOME_FAQ;
